import styled from 'styled-components';

// O `FederatedDrawer.css` zera o padding de todo `.ant-drawer-body` com
// `!important`; o respiro do painel mora aqui.
export const Content = styled.div`
  padding: 4px 20px 20px;

  .ant-tabs-nav {
    margin-bottom: 16px;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-size: 12px;
  color: #44566c;

  label {
    display: block;
    margin-bottom: 4px;
    color: #8697a8;
  }
`;

export const Hint = styled.div`
  color: #8697a8;
`;

export const Field = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const ModelRow = styled.div`
  padding: 2px 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const RuleRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 6px 0;
  border-bottom: 1px solid #f0f2f4;

  .ruleText {
    flex: 1;
    min-width: 0;
  }

  .ruleName {
    font-weight: 600;
  }

  .ruleTypes {
    color: #8697a8;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const TypeRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 4px 2px 0;

  .count {
    color: #8697a8;
    font-variant-numeric: tabular-nums;
  }
`;

export const Summary = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;

  .count {
    font-size: 20px;
    font-weight: 600;
  }
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const IssueHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 6px 4px 4px;
  font-weight: 600;
  background: #ffffff;
  border-bottom: 1px solid #eaedf0;
`;

export const ClashRow = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  padding: 6px 4px;
  border: none;
  border-radius: 4px;
  text-align: left;
  cursor: pointer;
  color: inherit;
  background: ${({ $active }) => ($active ? '#e8f0fe' : 'transparent')};

  &:hover {
    background: ${({ $active }) => ($active ? '#e8f0fe' : '#f5f6f8')};
  }

  .sides {
    flex: 1;
    min-width: 0;
  }

  .side {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .type,
  .rule {
    color: #8697a8;
  }

  .distance {
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
  }
`;
